module.exports = __webpack_public_path__ + "assets/img/A.4213b858.png";